export const familiplusBox = {
  width: '100%',
  background: '#FFFFFF',
  boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  borderRadius: '6px',
  marginTop: '24px',
};

export const familiplusBoxGrid = {
  display: 'grid',
  gridTemplateRows: 'repeat(2, fit-content(100%))',
  rowGap: '16px',
  padding: '16px',
};

export const familiplusBoxInfo = {
  display: 'grid',
  gridTemplateRows: 'repeat(3, fit-content(100%))',
  rowGap: '8px',
  paddingLeft: '8px',
  paddingRight: '8px',
};

export const familiplusLogo = {
  width: '150px',
  marginLeft: '-2px',
};

export const familiplusTitle = {
  color: '#EA0404',
  fontWeight: '700',
  fontSize: '20px',
};

export const familiplusLabel = {
  fontSize: '14px',
  color: '#002C53',
  lineHeight: '18px',
};

export const familiplusBoxAdvantages = {
  display: 'grid',
  gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
  gap: '16px',
};

export const familiplusBoxAdvantageBox = {
  display: 'grid',
  gridTemplateRows: 'repeat(2, fit-content(100%))',
  rowGap: '16px',
  boxSizing: 'border-box',
  border: '1px solid #CDD9E3',
  borderRadius: '6px',
  padding: '16px',
};

export const familiplusIcon = {
  width: '48px',
  height: '48px',
};

export const familiplusAdvantageLabel = {
  fontSize: '14px',
  fontWeight: '500',
  color: '#002342',
  lineHeight: '18px',
};
